import { requestChangeView, getViewState } from "../../externalApi/WindowApi";
// Expose window view APIs
export class WidgetWindowView {
    async requestChangeView(isExtended) {
        return await requestChangeView(isExtended);
    }
    async getViewState() {
        return await getViewState();
    }
}
